
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"58","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#56BDD2","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M21.488 22.538a1.7 1.7 0 00-2.478-.004l-5.762 6.04-2.261-2.373a1.696 1.696 0 00-2.475 0 1.897 1.897 0 000 2.593l3.5 3.667c.34.36.788.539 1.236.539.448 0 .896-.18 1.24-.535l7-7.334a1.897 1.897 0 000-2.593zM21.488 36.538a1.7 1.7 0 00-2.478-.004l-5.762 6.04-2.261-2.369a1.696 1.696 0 00-2.475 0 1.897 1.897 0 000 2.593l3.5 3.667c.34.355.788.535 1.236.535.448 0 .896-.18 1.24-.535l7-7.334a1.897 1.897 0 000-2.593zM35.167 26h-7.334C26.821 26 26 26.896 26 28s.821 2 1.833 2h7.334C36.179 30 37 29.104 37 28s-.821-2-1.833-2zM35.167 40h-7.334C26.821 40 26 40.896 26 42s.821 2 1.833 2h7.334C36.179 44 37 43.104 37 42s-.821-2-1.833-2z"}}),_c('path',{attrs:{"d":"M40.333 7.25H33V5.437c0-1-.821-1.812-1.833-1.812h-3.979A5.511 5.511 0 0022 0a5.511 5.511 0 00-5.188 3.625h-3.979A1.824 1.824 0 0011 5.438V7.25H3.667C1.647 7.25 0 8.878 0 10.875v43.5C0 56.372 1.646 58 3.667 58h36.666C42.353 58 44 56.372 44 54.375v-43.5c0-1.997-1.646-3.625-3.667-3.625zm-25.666 0h3.666a1.824 1.824 0 001.834-1.813c0-1 .821-1.812 1.833-1.812s1.833.812 1.833 1.813c0 1 .822 1.812 1.834 1.812h3.666v3.625H14.667V7.25zm25.666 47.125H3.667v-43.5H11v1.813c0 1 .821 1.812 1.833 1.812h18.334A1.824 1.824 0 0033 12.687v-1.812h7.333v43.5z"}})])])
          )
        }
      }
    